// Firm Contact Info Component
// Phone number and email settings with preview

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Phone } from 'lucide-react';

const FirmContactInfo = ({ firmPhone, firmEmail, onChange }) => {
  return (
    <Card className="border-slate-200 lg:col-span-2">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Phone className="w-5 h-5 text-teal-500" />
          Firm Contact Info
        </CardTitle>
        <CardDescription>
          Contact information displayed in client follow-up emails. This is how potential clients can reach your firm.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="firm_phone">Firm Phone Number</Label>
            <Input
              id="firm_phone"
              value={firmPhone || ''}
              onChange={(e) => onChange('firm_phone', e.target.value)}
              placeholder="(555) 123-4567"
              className="mt-1"
              data-testid="firm-phone-input"
            />
            <p className="text-xs text-slate-500 mt-1">Shown in follow-up emails as &quot;Call us at...&quot;</p>
          </div>
          
          <div>
            <Label htmlFor="firm_email">Firm Email Address</Label>
            <Input
              id="firm_email"
              type="email"
              value={firmEmail || ''}
              onChange={(e) => onChange('firm_email', e.target.value)}
              placeholder="contact@yourfirm.com"
              className="mt-1"
              data-testid="firm-email-input"
            />
            <p className="text-xs text-slate-500 mt-1">Shown in follow-up emails as &quot;Email us at...&quot;</p>
          </div>
        </div>
        
        {/* Preview of contact line */}
        <div className="mt-4 p-4 bg-slate-50 rounded-lg border border-slate-200">
          <p className="text-xs text-slate-500 mb-2 uppercase tracking-wide">Preview in emails:</p>
          <p className="text-sm text-slate-700">
            {firmPhone && firmEmail ? (
              <>Call us at <span className="font-medium">{firmPhone}</span> or email <span className="font-medium">{firmEmail}</span></>
            ) : firmPhone ? (
              <>Call us at <span className="font-medium">{firmPhone}</span></>
            ) : firmEmail ? (
              <>Email us at <span className="font-medium">{firmEmail}</span></>
            ) : (
              <span className="text-slate-400 italic">Add your phone or email to see preview</span>
            )}
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default FirmContactInfo;
